/**
 * Contrato de tipos de notificação (alinhado ao payload futuro do socket).
 * @typedef {keyof typeof NOTIFICATION_TYPES} NotificationType
 */

export const NOTIFICATION_TYPES = {
  chat_message: "chat_message",
  new_request: "new_request",
  request_assigned: "request_assigned",
  /** SLA de primeira resposta (automação) — som/prefs alinhados a new_request */
  response_sla: "response_sla",
  /** Ligação aguardando na fila de telefone (toast/desktop/e-mail offline) */
  voice_queue: "voice_queue",
  /** Ring de transferência humana (softphone ou PSTN no celular do agente) */
  voice_call: "voice_call",
  system: "system",
  billing: "billing",
  security: "security",
  /** Metadado: chamada já tratada pelo CallContext — não duplicar som. */
  call_incoming: "call_incoming",
  /** Compat Cockpit: socket `notification` genérico */
  legacy_socket: "legacy_socket",
  /** Chat interno de equipe — mensagem em canal/DM */
  team_message: "team_message",
  /** Menção @usuário em canal de equipe */
  team_mention: "team_mention",
  /** Compromisso na agenda (manual ou Google) */
  agenda_reminder: "agenda_reminder",
  /** Relatório pesado do dashboard concluído em background */
  dashboard_report_ready: "dashboard_report_ready",
  /** Tarefa com prazo próximo */
  task_due: "task_due",
  /** Tarefa com prazo vencido */
  task_overdue: "task_overdue",
  /** Tarefa concluída (solicitação / escalonamento) */
  task_completed: "task_completed",
  /** Convite para participar de um painel de tarefas */
  task_board_invite: "task_board_invite",
  /** Master recebeu acesso a workspace(s) no console da plataforma */
  platform_workspace_access: "platform_workspace_access",
};

/** @param {string} v */
export function isNotificationType(v) {
  return typeof v === "string" && Object.prototype.hasOwnProperty.call(NOTIFICATION_TYPES, v);
}

/**
 * @typedef {Object} PlatformNotificationPayload
 * @property {NotificationType} type
 * @property {string} title
 * @property {string} [body]
 * @property {string} [conversationId]
 * @property {string} [deepLink] rota interna, ex. /chat/123
 * @property {string} [dedupeKey]
 * @property {boolean} [skipSound]
 * @property {boolean} [skipDesktop]
 * @property {boolean} [openLinkInNewTab] ex.: alertas do Xpro 2 (legado)
 */

export const DEFAULT_DEDUPE_TTL_MS = 12_000;
